<template>
    <svg baseProfile="full"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:ev="http://www.w3.org/2001/xml-events"
      width="100%" height="100%">

    <svg x="0" y="0" width="100%" height="100%" viewBox="0 0 42 42" preserveAspectRatio="xMidYMid">
      <circle class="donut-hole" cx="21" cy="21" :r="radius" fill="#fff"></circle>
      <circle
        v-for="(segment, index) in segments" :key="index"
        cx="21"
        cy="21"
        :r="segment.radius"
        fill="transparent"
        :stroke="segment.color"
        :stroke-width="segment.width"
        :stroke-dasharray="segment.strokeDasharray"
        :stroke-dashoffset="segment.strokeDashoffset"
        style="transition: 'stroke-dasharray 0.5s ease-in-out, stroke-dashoffset 0.5s ease-in-out';">
      </circle>
    </svg>

    <g>
      <text x="50%" y="50%" ref="totalValue" class="chart-number">
        <tspan :fill="hole.color">{{ hole.value(series.data) }}</tspan>
      </text>
      <circle cx="50%" cy="70%" :r="15" fill="transparent" stroke-width="1" stroke="#eee"></circle>
      <text x="50%" y="50%" class="chart-label" fill="dark-gray">
        <tspan dy="18" class="chart-unit" >{{ hole.unit }}</tspan>
        <!--
        {{ hole.text }}
        -->
      </text>
    </g>

    <svg x="0" y="0" width="100%" height="100%" viewBox="0 0 42 42" preserveAspectRatio="xMidYMid">
      <circle class="pointer donut-hole" cx="21" cy="21" :r="radius" fill="transparent" @click.prevent="nextHole"></circle>
    </svg>

  </svg>
</template>

<script>

const pi = 22 / 7

export default {
  props: {
    series: {
      type: Object,
      default: null
    },
    strokeWidth: {
      type: Number,
      default: 5
    }
  },
  data () {
    return {
      radius: 21 - this.strokeWidth / 2,
      holeIndex: 0
    }
  },
  computed: {
    total () {
      return this.series.data.reduce((sum, { value }) => {
        return sum + value
      }, 0)
    },
    hole () {
      return this.series.hole[this.holeIndex % this.series.hole.length]
    },
    segments () {
      const circumference = 2 * pi * this.radius
      const offset = circumference / 4 // сдвигаем на 90 градусов, чтобы встало на 12 часов
      const total = this.total
      let acc = 0
      return this.series.data.map(({ value, color }, index) => {
        const percent = value / total
        const arcLength = circumference * percent
        const spaceArcLength = circumference - arcLength
        acc += arcLength
        return {
          percent: percent,
          strokeDasharray: `${arcLength} ${spaceArcLength}`,
          strokeDashoffset: offset + circumference - (acc - arcLength),
          radius: this.radius,
          width: this.strokeWidth,
          color: color
        }
      })
    }
  },
  methods: {
    nextHole () {
      this.holeIndex++
    }
  }
}
</script>

<style scoped>
* {
  -webkit-box-sizing: border-box;
     -moz-box-sizing: border-box;
          box-sizing: border-box;
}
.chart-text {
  /*font: 16px/1.4em "Montserrat", Arial, sans-serif;*/
  fill: #000;
  -moz-transform: translateY(0.25em);
  -ms-transform: translateY(0.25em);
  -webkit-transform: translateY(0.25em);
  transform: translateY(0.25em);
}
.chart-number {
  font-size: 24px;
  line-height: 1;
  text-anchor: middle;
  /* dominant-baseline: middle; */
  font-family: sans-serif;
  -moz-transform: translateY(5px);
  -ms-transform: translateY(5px);
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
}
.chart-unit {
  font-size: 12px;
  line-height: 1;
  text-anchor: middle;
  font-family: sans-serif;
  color: silver;
}
.chart-label {
  font-size: 12px;
  text-anchor: middle;
  font-family: sans-serif;
  -moz-transform: translateY(15px);
  -ms-transform: translateY(15px);
  -webkit-transform: translateY(15px);
  transform: translateY(15px);
}

@media screen and (min-width: 60em) {
  .chart-number {
    font-size: 2.25rem;
    line-height: 1;
    text-anchor: middle;
    font-family: sans-serif;
    -moz-transform: translateY(5px);
    -ms-transform: translateY(5px);
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
  }
  .chart-unit {
    font-size: 16px;
    line-height: 1;
    text-anchor: middle;
    font-family: sans-serif;
  }
  .chart-label {
    font-size: 16px;
    text-anchor: middle;
    font-family: sans-serif;
    -moz-transform: translateY(18px);
    -ms-transform: translateY(18px);
    -webkit-transform: translateY(18px);
    transform: translateY(18px);
  }
}
</style>
